'use client';

import {
  Box,
  Divider,
  freddyTheme,
  List,
  ListItem,
  Typography
} from '@coolblue-development/freddy';
import { Checkmark } from '@coolblue-development/icons';
import { useTranslation } from '@i18n/useTranslation';

import { USP_TEXT_KEYS } from './constants';

type VacancyDividerProps = {
  showUsps: boolean;
};

export const VacancyDivider = ({ showUsps = false }: VacancyDividerProps) => {
  const { t } = useTranslation('filterPage.uspTexts');

  return showUsps ? (
    <>
      <Divider
        sx={{
          [freddyTheme.breakpoint.maxWidth('md')]: {
            '&::before': { margin: 0 },
            '&::after': { margin: 0 }
          }
        }}
      >
        <List
          orientation='horizontal'
          sx={{
            display: 'flex',
            flexDirection: 'row'
          }}
          hideUntil='md'
        >
          {USP_TEXT_KEYS.map(key => (
            <ListItem key={key}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: freddyTheme.spacing[200]
                }}
              >
                <Checkmark color={freddyTheme.color.border.sentimentPositive} />
                <Typography>{t(key)}</Typography>
              </Box>
            </ListItem>
          ))}
        </List>
      </Divider>
    </>
  ) : (
    <Divider />
  );
};
